<script setup>
const props = defineProps(["related_products", "parent_collection"]);

import Product from "@/components/cards/Product.vue";
</script>

<template>
	<section class="py-48 lg:pt-48 lg:pb-96">
		<div class="container">
			<div class="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
				<Product
					v-for="product in related_products"
					:key="product.id"
					:product="product"
				/>
			</div>
		</div>
	</section>
</template>
